var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeetingRoomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7778 19.5556H19.5556V2.44444C19.5556 1.77222 19.0056 1.22222 18.3333 1.22222H13.4444C13.4444 0.55 12.8944 0 12.2222 0H3.66667C2.99444 0 2.44444 0.55 2.44444 1.22222V19.5556H1.22222C0.55 19.5556 0 20.1056 0 20.7778C0 21.45 0.55 22 1.22222 22H12.2222C12.8944 22 13.4444 21.45 13.4444 20.7778V3.66667H17.1111V20.7778C17.1111 21.45 17.6611 22 18.3333 22H20.7778C21.45 22 22 21.45 22 20.7778C22 20.1056 21.45 19.5556 20.7778 19.5556ZM9.77778 12.2222C9.10556 12.2222 8.55556 11.6722 8.55556 11C8.55556 10.3278 9.10556 9.77778 9.77778 9.77778C10.45 9.77778 11 10.3278 11 11C11 11.6722 10.45 12.2222 9.77778 12.2222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingRoomIcon);
export default __webpack_public_path__ + "static/media/meeting-room-icon.66d168c6aad028e8636e5c15bac14b0b.svg";
export { ForwardRef as ReactComponent };